<script lang="ts">
  import Stack from "../../Stack.svelte";
  import OverlayButton from "../../buttons/OverlayButton.svelte";
  import PagingButton from "../../buttons/PagingButton.svelte";
  import Pdf from "../../data-display/PDF.svelte";
  import Icon from "../../icons/Icon.svelte";

  export let url: string;
  export let filename: string = url;
  export let zoomed: boolean = false;
  export let showDownload = false;
  export let showGradient = true;
  export let condensed = false;

  let currentPage: number = 1;
  let pdfPageCount: number;

  function previousPage() {
    currentPage -= 1;
  }

  function nextPage() {
    currentPage += 1;
  }

  async function downloadPdf() {
    const response = await fetch(url);
    const blob = await response.blob();
    const urlObject = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = urlObject;
    link.download = `${filename}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
</script>

<div class="pdf-container" class:condensed class:zoomed>
  <Pdf {url} page={currentPage} bind:pageCount={pdfPageCount} />

  {#if showGradient && !zoomed}
    <div class="gradient" />
  {/if}
</div>
<div class="actions">
  <Stack horizontal justifyContent="space-between" spacing="small">
    {#if showDownload}
      <OverlayButton onClick={downloadPdf}>
        <Icon slot="icon" name="download" --w="24px" --h="24px" --color="var(--rekki-light)" />
      </OverlayButton>
    {/if}
    <Stack horizontal justifyContent="flex-end" spacing="small">
      {#if pdfPageCount > 1}
        <PagingButton
          onNext={nextPage}
          onPrevious={previousPage}
          previousDisabled={currentPage === 1}
          nextDisabled={currentPage === pdfPageCount}
        />
      {/if}
      <OverlayButton
        onClick={() => {
          zoomed = !zoomed;
        }}
      >
        <Icon
          slot="icon"
          name={zoomed ? "collapse" : "expand"}
          --w="24px"
          --h="24px"
          --color="var(--rekki-light)"
        />
      </OverlayButton>
    </Stack>
  </Stack>
</div>

<style>
  .pdf-container {
    margin: 16px 88px 0 88px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05), 0px 36px 87px 0px rgba(0, 0, 0, 0.09);
    transition: margin 0.3s ease-in-out;
    min-height: 320px;
  }

  .condensed {
    margin: 16px 64px;
  }

  .zoomed {
    margin: 8px;
  }

  .condensed.zoomed {
    margin: 16px;
  }

  .gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 88px;
    background: linear-gradient(180deg, rgba(248, 248, 248, 0) 0%, #f8f8f8 100%);
  }
  .actions {
    position: sticky;
    bottom: 8px;
    padding: 16px 8px 0px 8px;
    pointer-events: none;
  }
</style>
